import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const LoginForm = ({ checkCredentials, setError, t }) => {
  const username = React.createRef()
  const password = React.createRef()

  const getCredentials = () => (
    {
      username: username.current.value,
      password: password.current.value,
    }
  )

  const onSubmit = (e) => {
    e.preventDefault()
    checkCredentials(getCredentials())
      .catch(setError)
  }

  return (
    <>
      <form id='login-form' onSubmit={onSubmit}>
        <label>
          { t('forms.labels.username') }:
          <input
            id='username'
            type='text'
            name='username'
            autoCorrect='off'
            autoCapitalize='none'
            ref={username}
          />
        </label>
        <label>
          { t('forms.labels.password') }:
          <input
            id='password'
            type='password'
            name='password'
            ref={password}
          />
        </label>
        <Link to={'/password/reset'}>
          { t('forms.login.forgotten') }
        </Link>
        <button type='submit'>
          { t('forms.login.button') }
        </button>
      </form>
    </>
  )
}

LoginForm.propTypes = {
  checkCredentials: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default LoginForm
